// extracted by mini-css-extract-plugin
module.exports = {"wrp":"Footer_wrp__3RdDv","textItemWrp":"Footer_textItemWrp__3DOp3","iconWrp":"Footer_iconWrp__Zx30y","footerLogoWrp":"Footer_footerLogoWrp__2ObHV"};